import { type FunctionComponent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { INTERNAL_FIND_CUSTOMER_LINK, LOGGING_IN_AS_A_CUSTOMER_DOCS } from '../../../constants/links';
import { emailInputRegistrationConfig } from '../../../helpers/form-validation-helper/form-validation-helper';
import { StyledButton } from '../../buttons';
import { StyledLink } from '../../common-components/link/styled-link.component';
import { TextInput } from '../../inputs/input/text-input/text-input.component';
import FergusonIsotypeIcon from '../../svgs/ferguson-isotype.svg';
import { LoginCustomerModal } from '../login-customer-modal/login-customer-modal.component';

type FormInputs = {
	internalEmail: string;
};

export type InternalLoginFormProps = {
	onLoginSuccess?: () => void;
};

export const InternalLoginForm: FunctionComponent<InternalLoginFormProps> = ({ onLoginSuccess }) => {
	const [showCustomerList, setShowCustomerList] = useState(false);

	const onSubmit = () => {
		setShowCustomerList(true);
	};

	const closeListModal = () => setShowCustomerList(false);

	const onLoginComplete = () => {
		closeListModal();
		if (onLoginSuccess) {
			onLoginSuccess();
		}
	};

	const {
		register,
		handleSubmit,
		formState: { isValid, errors },
		getValues
	} = useForm<FormInputs>({ mode: 'onSubmit', reValidateMode: 'onChange' });

	return (
		<>
			<div className="flex flex-column pa3 bg-theme-internal-lighter br2">
				<span className="flex f5 lh-title items-center font-medium">
					<FergusonIsotypeIcon className="pr1 f7" /> Log In as Customer
				</span>
				<form onSubmit={handleSubmit(onSubmit)} aria-label="internal login form">
					<div className="pv2 f7 lh-copy">
						Log In as a customer to view their Projects, order history, account, and cart.
						<StyledLink className="ph1" color="internal" url={LOGGING_IN_AS_A_CUSTOMER_DOCS} openInNewTab>
							View Documentation
						</StyledLink>
					</div>
					<div className="flex flex-column bg-theme-white pa3 pt1 br1">
						<TextInput
							label="Email"
							placeholder="Email"
							className="pt2"
							required={true}
							data-testid="emailInput"
							invalid={Boolean(errors.internalEmail)}
							invalidMessage={errors.internalEmail?.message}
							{...register('internalEmail', { ...emailInputRegistrationConfig })}
							automationHook="login-as-customer-email"
						/>
						<div className="pt3 flex flex-column flex-row-ns items-center">
							<StyledButton
								buttonStyle="INTERNAL"
								buttonType="submit"
								disabled={!isValid}
								automationHook={'login-as-customer'}>
								Log In As Customer
							</StyledButton>
							<div className="ml3 mt2 mt0-ns f5">
								<StyledLink color="internal" url={INTERNAL_FIND_CUSTOMER_LINK} automationHook="find-customer">
									Find Customer
								</StyledLink>
							</div>
						</div>
					</div>
				</form>
			</div>
			{showCustomerList && (
				<LoginCustomerModal
					searchCriteria={{ email: getValues().internalEmail }}
					onLoginSuccess={onLoginComplete}
					onClose={closeListModal}
				/>
			)}
		</>
	);
};
